
import SimpleHeader from "components/Headers/SimpleHeader.jsx";
import React from "react";
import {
    Button,
    Card,
    CardBody,
    CardHeader,
    Col,
    Container,
    Form,
    FormGroup, Input,
    InputGroup,
    InputGroupAddon, InputGroupText, Modal,
    Row,
} from "reactstrap";
import MeetingReportService from "../../../services/meetingReportService";
import SummaryForm from "../summary/Form";
import _ from "lodash";
import ContactService from "../../../services/contactService";
import UtilService from "../../../services/utilService";
import AdminService from "../../../services/adminService";
import ContentService from "../../../services/xgContentService";
import SummaryService from "../../../services/summaryService";
import NotificationAlert from "react-notification-alert";
import SummaryDetails from "../summary/Details";
import ProjectService from "../../../services/projectService";
import Loader from "../../Loader";
import ReactBSAlert from "react-bootstrap-sweetalert";
import formatFrontendDate from "../util/formatFrontendDate";

class MeetingDetails extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            contentData: {},
            errorObj : {},
            attendeesSelectKey :UtilService.uuidv4(),
            attendesForSelection : [],
            loading:false,
            alert:null
        };

        this.handleSummarySubmit = this.handleSummarySubmit.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleAttendeesChange = this.handleAttendeesChange.bind(this);
    }
    handleChange(event) {
        this.setState({[event.target.name]: event.target.value});
        console.log(this.state);
    }

    componentDidMount() {
        this.populateMeetingReportData();
        ProjectService.list().then((response) => {
            console.log("Project List....");
            console.log(response);
            this.setState({attendesForSelection: response, attendeesSelectKey :UtilService.uuidv4() });
        });
        console.log(this.state)
    }

    populateMeetingReportData() {
        const {uniqueId} = this.props.match.params;
        this.setState({meetingReportUID: uniqueId})
        MeetingReportService.fetch(uniqueId).then((response) => {
            console.log(response.data);
            this.setState({contentData: response.data});
        });
    }

    handleAttendeesChange = (valueObj,event) => {
        if (_.isNull(valueObj)) {
            this.setState({selectedAttendees: []});
        } else {
            this.setState({selectedAttendees: valueObj});
            const attendees = _.map(valueObj, "uniqueId")
            this.setState({sharedWith: attendees});
        }
    }

    toggleModal = state => {
        this.setState({
            [state]: !this.state[state]
        });
    };

    hideDeleteAlert = () => {
        this.setState({
            alert: null
        });
    };

    confirmDeleteAlert = (uniqueId) => {
        this.setState({
            alert: (
                <ReactBSAlert
                    warning
                    style={{display: "block"}}
                    title="Are you sure?"
                    onConfirm={() => this.delete(uniqueId)}
                    onCancel={this.hideDeleteAlert}
                    showCancel
                    confirmBtnBsStyle="danger"
                    confirmBtnText="Yes, delete it!"
                    cancelBtnBsStyle="secondary"
                    cancelBtnText="Cancel"
                    btnSize=""
                >
                    You won't be able to revert this!
                </ReactBSAlert>
            )
        });
    };

    delete(uniqueId) {
        this.setState({alert: null})
        SummaryService.delete(uniqueId).then((response) => {
            console.log(response);
            this.notify(
                response.responseStatus.toLowerCase(),
                response.responseStatus,
                response.message
            );
            //TODO: TO be fixed with redux implementation
            //   this.props.history.push("/admin/dashboard");
            setTimeout(() => {
                window.location.reload();
            }, 3000)
        });
    }

    handleEditorChange = (value) => {
        this.setState({ text: value });
    };

    notify = (type, title, message) => {
        let options = {
            place: "tc",
            message: (
                <div className="alert-text">
          <span className="alert-title" data-notify="title">
            {title}
          </span>
                    <span data-notify="message">{message}</span>
                </div>
            ),
            type: type,
            icon: "ni ni-bell-55",
            autoDismiss: 5,
        };
        this.refs.notificationAlert.notificationAlert(options);
    }

    handleSummarySubmit (event) {
        event.preventDefault();
        this.setState({loading:true});
        const {uniqueId} = this.props.match.params;
        SummaryService.create(this.state).then(response => {
            this.notify(
                response.responseStatus.toLowerCase(),
                response.responseStatus,
                response.message
            );
            if (response.responseStatus === "SUCCESS") {
                this.toggleModal("formModal");
                this.setState({loading:false});
                window.location.reload()
            } else {
                this.setState({loading:false});
                this.setState({errorData: response.data});
                console.error("Error    ==>     " + response.message);
            }
        });
    }

    render() {
        const {contentData} = this.state;
        return (
            <>
                <div className="rna-wrapper">
                    <NotificationAlert ref="notificationAlert"/>
                </div>
                <SimpleHeader
                    name="Details"
                    parentName="Meeting"
                    heading="XareGrowth"
                    newBtnUrl="/crm/meetingReport/list"
                    newBtnText="List All Meetings"
                />
                {this.state.loading && <Loader />}
                {this.state.alert}
                <Container className="mt--6" fluid>
                    <Card className="mb-4">
                        <CardHeader>
                            <h3 className="mb-0">{contentData?.company?.legalName}</h3>
                        </CardHeader>
                        <CardBody>
                            <Row>
                                <Col md="4">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="example3cols1Input"
                                        >
                                            Date
                                        </label>
                                        <p>{formatFrontendDate(contentData.date)}</p>
                                    </FormGroup>
                                </Col>
                                <Col md="4">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="example3cols2Input"
                                        >
                                            Event Type
                                        </label>
                                        <p>
                                            {contentData.eventType}
                                        </p>
                                    </FormGroup>
                                </Col>
                                <Col md="4">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="example3cols3Input"
                                        >
                                            Company
                                        </label>
                                        <p>{contentData?.company?.legalName}</p>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="4" sm="6">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="example4cols1Input"
                                        >
                                            Attendees
                                        </label>
                                        <p>{contentData?.attendees?.map(function (value, index) {
                                            return <h4 key={index}
                                                       className="badge badge-lg badge-primary">{value.fullName}</h4>
                                        })}</p>
                                    </FormGroup>
                                </Col>
                                <Col md="4" sm="6">
                                    <FormGroup>
                                        <label
                                            className="form-control-label"
                                            htmlFor="example4cols2Input"
                                        >
                                            Date Created
                                        </label>
                                        <p>{formatFrontendDate(contentData.dateCreated)}</p>
                                    </FormGroup>
                                </Col>
                            </Row>
                        </CardBody>
                    </Card>

                    <Row>
                        <Col md="12">
                            <Button
                                block
                                color="default"
                                type="button"
                                onClick={() => this.toggleModal("formModal")}
                            >
                                Add Summary
                            </Button>
                            <Modal
                                className="modal-dialog-centered"
                                size="lg"
                                isOpen={this.state.formModal}
                                toggle={() => this.toggleModal("formModal")}
                            >
                                <div className="modal-body p-0">
                                    <Card className="bg-secondary shadow border-0">
                                        <CardHeader className="bg-transparent pb-5">
                                            <div className="text-muted text-center mt-2 mb-3">
                                                <h2>Add Summary</h2>
                                            </div>
                                        </CardHeader>
                                        <CardBody className="px-lg-5 py-lg-5">
                                            <Form role="form" onSubmit={this.handleSummarySubmit}>
                                                <SummaryForm onChange={this.handleChange}
                                                             onEditorChange={this.handleEditorChange}
                                                             valueObj={this.state}
                                                             errorObj={this.state.errorData}
                                                             attendeesSelectkey={this.state.attendeesSelectKey}
                                                             handleAttendeesChange={this.handleAttendeesChange}
                                                             selectedAttendees={this.state.selectedAttendees}
                                                             attendesForSelection={this.state.attendesForSelection}
                                                />
                                                <div className="text-center">
                                                    <Button className="my-4" color="info" type="submit">
                                                        Submit
                                                    </Button>
                                                </div>
                                            </Form>
                                        </CardBody>
                                    </Card>
                                </div>
                            </Modal>
                        </Col>
                    </Row>
                    <br/>
                    <br/>
                    <br/>
                    <br/>
                    <Row>
                        <Col md="12">
                        </Col>
                    </Row>

                    <Row>
                        <Col md="12">
                            {contentData?.summaries?.length > 0 ? (
                                contentData.summaries
                                    .slice()
                                    .sort((a, b) => new Date(b.dateCreated) - new Date(a.dateCreated))
                                    .map((summary, index) => (
                                        <div key={index}>
                                            <SummaryDetails summary={summary} index={index + 1} delete={this.confirmDeleteAlert}/>
                                        </div>
                                    ))
                            ) : (
                                <h3>No summaries available</h3>
                            )}
                        </Col>
                    </Row>
                </Container>
                <br/>
                <br/>
                <br/>
                <br/>
            </>
        );
    }
}

export default MeetingDetails;
